import React from 'react'
import styled, { css } from 'styled-components'

export const Toggle = ({
  className = '',
  color = '#65008a',
  value,
  onChange,
  disabled,
  text
}) => {
  return (
    <Root
      disabled={disabled}
      className={className}
      onClick={() => !disabled && onChange && onChange(!value)}
    >
      <ChildContainer>
        <ToggleBackground
          className='toggle-container'
          value={value}
          color={color}
        >
          <ToggleHandler className='toggle-thumb' value={value} />
        </ToggleBackground>
      </ChildContainer>
      {text && <div>{text}</div>}
    </Root>
  )
}

const Root = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.5;
    `}
`

const ChildContainer = styled.div`
  padding-right: 8px;
  margin-right: 2px;
`

const ToggleBackground = styled.span`
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
  width: 32px;
  height: 16px;
  transition-property: background-color, border-color, color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
  background-color: rgb(228, 228, 231);
  border-width: 2px;
  border-radius: 9999px;
  border-color: #e4e4e7;
  cursor: pointer;

  ${({ value, color }) =>
    value &&
    css`
      background-color: ${color};
    `}
`

const ToggleHandler = styled.span`
  display: inline-block;
  width: 12px;
  height: 12px;
  transition-property: background-color, border-color, color, fill, stroke,
    opacity, box-shadow, transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 9999px;
  box-shadow: 0 0 #000000, 0 0 #000000),
    0 0 #000000, 0 1px 3px 0 rgba(0, 0, 0, 0.1),
    0 1px 2px 0 rgba(0, 0, 0, 0.06);
  transform: translateX(0);

  ${({ value }) =>
    value &&
    css`
      transform: matrix(1, 0, 0, 1, 16, 0);
    `}
`
